import { Injectable } from '@angular/core';

@Injectable()
export class CommonUtils {
  public static sortColumn(obj: any, callbak?: any) {
    let sortedList;
    if (!obj.sortOnly) {
      if (!obj.sort.order || obj.sort.order === 'dsc') {
        obj.sort.order = 'asc';
      } else {
        obj.sort.order = 'dsc';
      }
    }
    if (obj.sort.order === 'asc') {
      sortedList = obj.data.sort((obj1, obj2) => {
        obj1[obj.sort.field] = obj1[obj.sort.field] ? obj1[obj.sort.field] : '';
        obj2[obj.sort.field] = obj2[obj.sort.field] ? obj2[obj.sort.field] : '';
        const fieldA = obj1[obj.sort.field].toString().toLowerCase();
        const fieldB = obj2[obj.sort.field].toString().toLowerCase();
        return fieldA !== fieldB ? fieldA < fieldB ? -1 : 1 : 0;
      });
    } else {
      sortedList = obj.data.sort((obj1, obj2) => {
        obj1[obj.sort.field] = obj1[obj.sort.field] ? obj1[obj.sort.field] : '';
        obj2[obj.sort.field] = obj2[obj.sort.field] ? obj2[obj.sort.field] : '';
        const fieldA = obj1[obj.sort.field].toString().toLowerCase();
        const fieldB = obj2[obj.sort.field].toString().toLowerCase();
        return fieldA !== fieldB ? fieldA > fieldB ? -1 : 1 : 0;
      });
    }
    obj.data = sortedList;
    if (callbak) {
      callbak(obj);
    }
  }

  public static hasClass(el, className) {
    if (el.classList) {
      return el.classList.contains(className);
    }
    return !!el.className.match(new RegExp('(\\s|^)' + className + '(\\s|$)'));
  }

  public static replaceSpaceWithUnderScore(path) {
    if (path) {
      return path.replace(/\s+/g, '_');
    }
  }

  public static addClass(el, className) {
    if (el.classList) {
      el.classList.add(className);
    } else if (!this.hasClass(el, className)) {
      el.className += ' ' + className;
    }
  }

  public static removeClass(el, className) {
    if (el.classList) {
      el.classList.remove(className);
    } else if (this.hasClass(el, className)) {
      const reg = new RegExp('(\\s|^)' + className + '(\\s|$)');
      el.className = el.className.replace(reg, ' ');
    }
  }

  public static emailValidation(emailList) {
    const emails = emailList.replace(/\s/g, '').split(';');
    let isValid = true;
    // tslint:disable-next-line:max-line-length
    const regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    for (const email of emails) {
      if (!regex.test(email)) {
        isValid = false;
      }
    }
    return isValid;
  }

  public static replaceMultipleWord(queryString) {
    const queryStr = queryString.replace(/[^\s]+/g, '"$&"');
    if (queryStr.indexOf(' ') !== -1) {
      return queryStr.trim().replace(/ +/g, ',');
    }
    return queryStr;
  }

  public static removeHTMLTags(str) {
    const value = str ? str.replace( /(<([^>]+)>)/ig, '') : '';
    return value;
  }
}
